import React, { FunctionComponent } from 'react';
import { TextBox } from '../../atoms/textBox'

type Props = {
  body: string;
  target: 'tel' | 'instagram' | 'twitter';
  onChangeBody: (name: string, value: string) => void;
 };

export const Presentation: FunctionComponent<Props> = ({
  body,
  target,
  onChangeBody,
}) => {
  const getTitle = () => {
    if (target === 'tel') return '電話番号';
    if (target === 'instagram') return 'Instagram ID';
    return (
      <>
        X<span className="sub">（旧Twitter）</span>ID
      </>
    );
  };

  return (
    <div className="person__show__modal__inner">
      <p className="person__show__modal__inner--title">
        {getTitle()}を入力して保存してください
      </p>
      <TextBox
        className="person__show__modal__inner--textbox"
        placeholder={
          target === 'tel'
            ? '012-3456-789'
            : '@を除いたIDのみを記入してください'
        }
        onChanged={(name, value) => onChangeBody(name, value)}
        name={target}
        value={body}
        type={target === 'tel' ? 'tel' : 'text'}
        pattern={target === 'tel' ? '' : '[a-zA-Z0-9_]*'}
      />
    </div>
  );
};
